/**
 * `heysegment pull` — download and unpack the session's version source.
 *
 * Thin wrapper over the shared `downloadAndUnpack` composite (see
 * `session/pull-core`): getPullUrl (RPC) → GET the presigned URL → unpack the
 * tarball over the project. The server's getPullUrl already recorded the base
 * revision + `pulled` event.
 *
 * @module
 */
import { Console, Effect } from "effect"
import { Command } from "effect/unstable/cli"
import { withSession } from "../session/with-session"
import { downloadAndUnpack } from "../session/pull-core"
import { readProjectSetup, renderPostPullSetup } from "../project-setup"
import { apiUrlFlag, dirFlag } from "./flags"

export const pullCommand = Command.make(
  "pull",
  { dir: dirFlag, apiUrl: apiUrlFlag },
  (flags) =>
    withSession({ dir: flags.dir, apiUrl: flags.apiUrl }, (session) =>
      Effect.gen(function* () {
        yield* downloadAndUnpack({ projectDir: session.projectDir })
        yield* Console.log(
          `✓ Pulled version ${session.versionId} into ${session.projectDir}`,
        )
        const setup = yield* readProjectSetup(session.projectDir)
        yield* Console.log(renderPostPullSetup(setup))
      }),
    ),
).pipe(Command.withDescription("Download and unpack the session's version source"))
